import { render, staticRenderFns } from "./TreatmentSummary.vue?vue&type=template&id=d1b55108"
import script from "./TreatmentSummary.vue?vue&type=script&lang=js"
export * from "./TreatmentSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports